module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/part1-3.f2c746c1.png";